import { sendCollabRequest, getReceivedRequests, getSentRequests, acceptCollab, declineCollab } from '@/services/collaborationsService'

var TTL_MS = 2 * 60 * 1000

function isFresh (ts) {
  return ts && (Date.now() - ts) < TTL_MS
}

export default {
  namespaced: true,
  state: function () {
    return {
      received: [],
      sent: [],
      loading: false,
      lastFetched: null
    }
  },
  getters: {
    RECEIVED: function (state) { return state.received },
    SENT: function (state) { return state.sent }
  },
  mutations: {
    SET_RECEIVED: function (state, items) { state.received = items },
    SET_SENT: function (state, items) { state.sent = items },
    SET_LOADING: function (state, val) { state.loading = val },
    SET_LAST_FETCHED: function (state) { state.lastFetched = Date.now() },
    REMOVE_RECEIVED: function (state, id) {
      state.received = state.received.filter(function (r) { return r.id !== id })
    },
    APPEND_SENT: function (state, req) {
      state.sent = state.sent.concat([req])
    }
  },
  actions: {
    FETCH: function (context, opts) {
      var force = opts && opts.force
      if (!force && isFresh(context.state.lastFetched)) {
        return Promise.resolve()
      }
      context.commit('SET_LOADING', true)
      return Promise.all([
        getReceivedRequests({ size: 20 }),
        getSentRequests({ size: 20 })
      ]).then(function (results) {
        context.commit('SET_RECEIVED', results[0].items)
        context.commit('SET_SENT', results[1].items)
        context.commit('SET_LAST_FETCHED')
        context.commit('SET_LOADING', false)
      }).catch(function (err) {
        context.commit('SET_LOADING', false)
        return Promise.reject(err)
      })
    },
    SEND_REQUEST: function (context, payload) {
      return sendCollabRequest(payload).then(function (req) {
        context.commit('APPEND_SENT', req)
        return req
      })
    },
    ACCEPT: function (context, id) {
      return acceptCollab(id).then(function () {
        context.commit('REMOVE_RECEIVED', id)
      })
    },
    DECLINE: function (context, id) {
      return declineCollab(id).then(function () {
        context.commit('REMOVE_RECEIVED', id)
      })
    }
  }
}
